import React from 'react';
import PropTypes from 'prop-types';
import { Avatar } from 'material-ui';
import { ListItem } from 'material-ui/List';
import CheckCircleIcon from 'material-ui/svg-icons/action/check-circle';
import muiThemeable from 'material-ui/styles/muiThemeable';
import withTranslation from '../../../hoc/withTranslation';
import style from '../../../styles/styles';

class UserAchievementItem extends React.Component {

    static propTypes = {
        userAchievement: PropTypes.object.isRequired
    };

    // Render

    renderPicture() {
        let achievement = this.props.userAchievement.achievement;
        if (achievement.picture && achievement.picture.length > 0) {
            return <Avatar src={achievement.picture} style={style.image.cover} />;
        }
        return <Avatar icon={<CheckCircleIcon />} />;
    }

    render() {
        const { userAchievement } = this.props;
        let createdDate = new Date();
        createdDate.setTime(userAchievement.created_at * 1000);
        return (
                <ListItem
                    insetChildren={true}
                    leftAvatar={this.renderPicture()}
                    primaryText={`${userAchievement.achievement.name} : ${userAchievement.user.email}`}
                    secondaryText={createdDate.toLocaleString()}
                    disableKeyboardFocus={true}
                    disabled={true}
                />
        );
    }
}

export default muiThemeable()(withTranslation(UserAchievementItem));



// WEBPACK FOOTER //
// src/components/achievement/UserAchievementItem/UserAchievementItem.js